import * as React from "react";

function Arrow(props) {
  return (
    <svg
      aria-label="Chevron icon to see all Follow Requests"
      className="prefix___8-yf5"
      fill="#8e8e8e"
      height={16}
      viewBox="0 0 48 48"
      width={16}
      data-metatip="true"
      {...props}
    >
      <path d="M40 33.5c-.4 0-.8-.1-1.1-.4L24 18.1l-14.9 15c-.6.6-1.5.6-2.1 0s-.6-1.5 0-2.1l16-16c.6-.6 1.5-.6 2.1 0l16 16c.6.6.6 1.5 0 2.1-.3.3-.7.4-1.1.4z" />
    </svg>
  );
}

export default Arrow;
